<template>
    <div>

        <div class="d-flex pb-3 mb-3 border-bottom-light justify-content-between align-items-center pointer" @click="toggleExpand">
            <span class="font-weight-600">RESOURCES</span>
            <i class="ico mx-0 fs-normal" :class="{'ico-arrow-top':group.resourcesExpanded, 'ico-arrow-bottom':!group.resourcesExpanded}"></i>
        </div>

        <div class="panelHolder" :class="{closed: !group.resourcesExpanded}">
            <div v-if="form.availabilityType == 2">
                <div class="d-flex align-items-start">
                    <!-- <checkbox class="d-inline" :disabled="disabled"></checkbox> -->
                    <span>Use this resources for other activities at the same time?</span>
                </div>
                <div class="mt-2 mb-3 fs-small dark">
                  <div class="d-flex">
                    <radio v-model="group.shareType" :value="0" class="d-inline" :disabled="disabled || form.isPrivate == true || form.productShareType == 2" :checked="form.isPrivate == true || form.productShareType == 2">
                        NO<br>
                    </radio >
                  </div>
                  <div class="d-flex mt-2">
                    <radio v-model="group.shareType" :value="1" class="d-inline" :disabled="disabled || form.isPrivate == true || form.productShareType == 2">
                        YES. Products that use the same resource at the same time will share availability. You can set max.seats per product.<br>
                    </radio >
                  </div>
                  <!-- <div class="d-flex mt-2">
                    <radio v-model="group.shareType" :value="2" class="d-inline" :disabled="disabled">
                        If a product is using the same resource at the same time, the first activity to be booked will turn the other activities unavailable to book.
                    </radio >
                  </div> -->
                </div>
            </div>

            <div v-if="availableResources == undefined" class="text-center dark">
                <div>Loading resources please wait</div>
            </div>
            <template v-esle>
                <div v-if="availableResources && availableResources !== undefined && availableResources.length > 0" class="">
                    <!-- <h5 class="border-bottom-lightest">What are the available resources?</h5> -->

                    <div class="form-group row">
                        <div class="col-sm-12">
                            <table class="table narrow">
                                <thead>
                                    <tr>
                                        <th class="pl-3" style="width: 40%;">Resource</th>
                                        <th class="pl-3" v-if="form.shareType == 2">Max. Seats</th>
                                        <th class="pl-3" v-else>Max. Seats</th>
                                        <th class="pl-3" style="width: 50px;">&nbsp;</th>
                                        <!-- <th class="pl-3">&nbsp;</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(resource, index) in group.resources">
                                        <td class="p-3">
                                            <v-select
                                                v-model="group.resources[index]"
                                                :options="availableResources"
                                                placeholder="- Select resource -"
                                                :searchable="false"
                                                label="name"
                                                :disabled="disabled"
                                                @input="updateResourcesList">
                                            </v-select>
                                        </td>
                                        <td class="pl-3" v-if="form.availabilityType == 2">
                                            <input type="number" style="width: 55px;" class="mr-2" :disabled="disabled" :class="{'border-color-6':resource.invalid}" v-model="resource.maxSeats" :max="fetchCapacity(resource)" @input="maxSeatsChanged(resource)"> /
                                            {{ fetchCapacity(resource) }}
                                            <span class="color-6 ml-2 fs-smaller" v-if="resource.invalid">Invalid</span>
                                        </td>
                                        <td class="pl-3" v-else>
                                            {{ fetchCapacity(resource) }}
                                        </td>
                                        <td>
                                            <i class="ico-delete largest medium" :class="{'pointer':!disabled, 'notAllowed':disabled}" @click="deleteRow(index, 'resources')"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div v-if="!readOnly" class="add d-flex align-items-center fs-small bold mt-5" :class="{'pointer':!disabled, 'notAllowed':disabled}" @click="addResource">
                                <i class="ico-add fs-smallest add-circle color-1"></i> Add resource
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="availableResources && availableResources.length == 0" class="text-center dark">
                    <div>⛵  You have no resources, let's add one to your inventory.</div>
                    <button type="button" class="btn mt-3" @click="createResource" :disabled="disabled">Create Resources</button>
                </div>
            </template>

        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import extendedVSelect from '@/extends/vue-select'
import {eventHub} from '@/main'

export default {
    data: function() {
        return {
            haveUserCreatedNewResource: 0,
        }
    },
    props: {
        form: {
            default: null
        },
        group:{
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        ...mapGetters([
            'account'
        ])
    },
    created: function() {

        //add listener to resource change (when user have no resources and uses te modal to create), we than update the available resurces
        eventHub.$on('updatedResources', event => {
            this.haveUserCreatedNewResource++
        });
    },
    asyncComputed: {
        availableResources: {
            async get () {
                try {
                    let response = await axios.get('/api/inventory/ListResource', { params: { supplierId: this.account.supplierId }});

                    if (response && response.status === 200 && response.data) {
                        // Map FK information through selects: for each ID found when editing, map
                        // the whole extra object for the dropdown
                        if(response.data.length > 0){
                            if (this.getSelectedItem) {
                                response.data.forEach(resource => {
                                });
                            }

                            // in case of no resources already associated with event, maybe set the [0] as associated?
                            //this.rebuildResourcesList(response.data);
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }

            },
            watch () {
                this.haveUserCreatedNewResource
            }
        },
    },
    methods: {
        ...mapActions([
            'openModal'
        ]),
        createEmptyResourceRow: function() {
            let resourceToCopy = this.availableResources[0]
            this.setMaxSeats(resourceToCopy)
            return resourceToCopy
        },
        updateResourcesList: function(resource) {
            // if (this.group.resources.resourcesList === undefined) {
            //     this.group.resources.resourcesList = [];
            // }

            //this.form.resources[index] = resource;
            // this.group.resources.resourcesList[index] = resource.id;


            console.log('resource', resource);
            this.setMaxSeats(resource)

            //
            // let index = this.form.resourcesList.indexOf(resource.id);
            //
            // if (index == -1) {
            //     this.form.resourcesList.push(resource.id);
            //
            //     if (resource.isFavorite) {
            //         this.form.favoriteResourceId = resource.id;
            //     }
            // }


            // this.$forceUpdate();

        },
        fetchCapacity: function(item) {
            return item ? item.availability : '-';
        },
        deleteRow: function(row, item) {
            if(this.disabled){
                return false
            }
            // Deletes selected row
            // works for resources and schedules

            switch (item) {
                case 'resources':
                    this.group.resources.splice(row, 1);
                    break;

                default:
                    break;
            }
            this.$forceUpdate();
        },
        createResource: function() {
            this.openModal('ResourceAdd')
        },
        addResource: function() {
            if(this.disabled){
                return false
            }

            console.log('resource added');
            if (this.group.resources === undefined) {
                this.$set(this.group, 'resources', []);
            }
            this.group.resources.push(this.createEmptyResourceRow()); // ok
            this.$forceUpdate(); //fixes this: https://vuejs.org/v2/guide/list.html#Array-Change-Detection
        },
        toggleExpand: function() {
            if(!this.group.resourcesExpanded){
                this.$set(this.group, 'resourcesExpanded', true)
            } else {
                this.group.resourcesExpanded = !this.group.resourcesExpanded
            }
        },
        setMaxSeats: function (resource) {
            if(!resource.maxSeats){
                this.$set(resource, 'maxSeats', this.fetchCapacity(resource))
            }
        },
        maxSeatsChanged: function(resource) {
            if(resource.maxSeats > this.fetchCapacity(resource)){
                this.$set(resource, 'invalid', true)
            } else {
                this.$set(resource, 'invalid', false)
            }
            // console.log(resource);
        }
    },
    components:{
        vSelect: extendedVSelect
    }
}
</script>

<style lang="scss" scoped="">
    .panelHolder{
        max-height: 800px;
        // transition: all 1300ms ease-in-out;
        overflow: visible;

        &.closed{
            max-height: 0;
            overflow: hidden;
        }
    }
</style>



// WEBPACK FOOTER //
// ResourcesManager.vue?7a08403f